export default {
  OPEN: "open",
  Rr: "purchase",
  vr: "push_click",
  ue: "custom_event",
  Qr: "iam_click",
  kt: "test",
};
